import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const lineColorsApiRoutes = {
    list: apiDataManagerBaseURL + "linecolors/",
    create: apiDataManagerBaseURL + "linecolors/",
    update: apiDataManagerBaseURL + "linecolors/",
    delete: apiDataManagerBaseURL + "linecolors/"
};

export class LineColorAPI {
    static list(provider = '') {
        const url = lineColorsApiRoutes.list;

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static create(color) {
        const url = lineColorsApiRoutes.create;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(color)
        });
    }

    static update(id, color) {
        const url = new URL(id, lineColorsApiRoutes.update);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(color)
        });
    }

    static delete(id) {
        const url = new URL(id, lineColorsApiRoutes.delete);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}